import { useEffect, useRef, useState } from "react";
import "./selectField.scss";

// Reusable V2 outlined select: value at inline-start, chevron at inline-end, dropdown option list.
function SelectField({ value, options = [], onSelect, placeholder = "" }) {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="v2-select" ref={ref}>
      <button type="button" className="v2-select-header" onClick={() => setIsOpen(!isOpen)}>
        <span className="v2-select-value">{value || placeholder}</span>
        <svg
          className={`v2-select-chevron${isOpen ? " v2-select-chevron--open" : ""}`}
          width="14"
          height="8"
          viewBox="0 0 14 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M1 1L7 7L13 1" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>

      {isOpen && (
        <ul className="v2-select-menu">
          {options.map((option) => (
            <li key={option.value}>
              <button
                type="button"
                className="v2-select-option"
                onClick={() => {
                  onSelect(option);
                  setIsOpen(false);
                }}
              >
                {option.label}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default SelectField;
